import { render, staticRenderFns } from "./yhteinen-sahkoposti.vue?vue&type=template&id=40d03590&"
import script from "./yhteinen-sahkoposti.vue?vue&type=script&lang=ts&"
export * from "./yhteinen-sahkoposti.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports